import { put, call, take, fork } from 'redux-saga/effects'
import { signUpService } from '../../api/sign-up'
import { signUpSuccess } from '../../reducers/sign-up/action.js'
import { SIGN_UP } from '../../reducers/sign-up/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

import { get as getCookie } from 'es-cookie'

/**
 *
 * @param {*} payload
 */
function* signUpSagaFlow(payload) {
  try {
    const { data } = payload
    const response = yield call(signUpService, data)

    yield put(signUpSuccess(response.data))

    try {
      const email = data?.email || getCookie('email')
      if (window.tolt && email) {
        window.tolt.signup(email)
      }
    } catch (e) {
      console.error(e)
    }

    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* signUpSagaWatcher() {
  while (true) {
    const action = yield take(SIGN_UP)
    const { payload } = action

    yield fork(generalSaga, signUpSagaFlow, payload)
  }
}
